<template>
  <list></list>
</template>

<script>
import List from "./../../components/product/list/List.vue";

export default {
  name: "ListForEdit",
  components: {
    List,
  },
};
</script>
